export const baseCustomer = {
	id: "",
	name: "",
	logo: "",
	seasons: [],
};
